import React, { useContext, useEffect, useState } from 'react';
import { getDealerCompanyUsers, removeDealerUser } from '../services/UserServices';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import { Spinner } from './Spinner';
import AddDealerModel from './AddDealerModel';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { showConfirmationAlert, showDefaultAlert } from '../utils/Alerts';
import UpdateDealerUserModel from './UpdateDealerUserModel';

const Users = () => {
  const { user, token } = useContext(UserContext);
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [update, setupdate] = useState(false);
  const [dealerUser, setdealerUser] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleupdateOpen = (dealerUser) => {
    setupdate(true);
    setdealerUser(dealerUser);
  };

  const handleUpdateClose = () => setupdate(false);

  const [userData, setUserData] = useState([]);

  const setNewDealer = (newDealer) => {
    setUserData(prevData => {
      const index = prevData.findIndex(item => item.UserID === newDealer.UserID);
      if (index !== -1) {
        const updatedItems = [...prevData];
        updatedItems[index] = newDealer;
        return updatedItems;
      } else {
        return [...prevData, newDealer];
      }
    });
  };

  const setUpdatedRecord = (updatedRecord) => {
    const updatedUserData = userData.map((user) => {
      if (user.UserID === updatedRecord.UserID) {
        return updatedRecord;
      }
      return user;
    });
    setUserData(updatedUserData);
  };


  const handleDelete = async (userID) => {
    const dealerID = user.DealerID;
    const adminID = user.UserID;
    const operation = 'remove';
    const confirmationMessage = 'Are you sure you want to delete the dealer member?';

    showConfirmationAlert({
      confirmationMessage,
      onConfirm: async () => {
        try {
          const response = await removeDealerUser(userID, dealerID, adminID, operation, token);
          if (response.status === 200) {
            showDefaultAlert('success', 'Success', `Successfully deleted the dealer member.`);
            setUserData((prevUserData) => prevUserData.filter((user) => user.UserID !== userID));
          }
        } catch (error) {
          console.log(error.response);
          setLoaded(false);
          if (error.response && error.response.status === 400) {
            if (error.response.data === "Dealer company not exists") {
              showDefaultAlert('error', 'Error', "Dealer company not exists");
            } else if (error.response.data === "User does not exist") {
              showDefaultAlert('error', 'Error', 'User does not exist');
            } else if (error.response.data === "User is not valid user") {
              showDefaultAlert('error', 'Error', 'User is not active dealer member.');
            } else (showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.'));
          } else {
            showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
          }
        }
      }
    });
  };

  useEffect(() => {
    const dealerID = user.DealerID;
    const adminID = user.UserID;

    setLoaded(true);
    const fetchUsers = async () => {
      try {
        const response = await getDealerCompanyUsers(dealerID, adminID, token);
        setUserData(response.data);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          if (error.response.data === "This dealer member already exists.") {
            showDefaultAlert('error', 'Error', "This dealer member already exists.");
          } else if (error.response.data === "This member belongs to another dealer company.'") {
            showDefaultAlert('error', 'Error', 'This member belongs to another dealer company.');
          }
        } else {
          showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
        }
      } finally {
        setLoaded(false);
      }
    };
    fetchUsers();
  }, [user.DealerID, user.UserID, token]);

  return (
    <>
      {loaded ? (
        <div className="middle">
          <Spinner></Spinner>
        </div>
      ) : (
        <Grid container justifyContent="center">
          <Grid item xs={12} md={11} lg={10} sx={{ mt: { xs: 3, sm: 6 }, px: { xs: 2, sm: 0 } }}>
            <Paper
              elevation={0}
              sx={{
                border: '1px solid #c52b2b',
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: '#ffffff'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  px: { xs: 2, sm: 3 },
                  py: { xs: 1.5, sm: 2 },
                  gap: 2,
                  flexWrap: 'wrap',
                  flexDirection: { xs: 'column', sm: 'row' },
                  backgroundColor: '#c52b2b',
                  color: '#ffffff'
                }}
              >
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Dealer Users
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Manage dealer team members
                  </Typography>
                </Box>
                  <Button
                    className="btn"
                    type="submit"
                    variant="contained"
                    onClick={handleOpen}
                    sx={{
                      backgroundColor: '#ffffff',
                      color: '#c52b2b',
                      border: '1px solid #ffffff',
                      fontWeight: 700,
                      width: { xs: '100%', sm: 'auto' },
                      '&:hover': { backgroundColor: '#f7dede', borderColor: '#f7dede' }
                    }}
                  >
                    Add Dealer
                  </Button>
                </Box>
              <Box sx={{ p: { xs: 2, sm: 3 } }}>
                {open && <AddDealerModel open={open} handleClose={handleClose} setNewDealer={setNewDealer} />}
                {update && <UpdateDealerUserModel open={update} handleUpdateClose={handleUpdateClose} setUpdatedRecord={setUpdatedRecord} dealerUser={dealerUser} />}
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    mx: 'auto',
                    border: '1px solid #f0f0f0',
                    borderRadius: 1.5,
                    width: { xs: '100%', md: '95%' },
                    maxWidth: '1400px',
                    overflowX: 'auto'
                  }}
                >
                  <Table sx={{ minWidth: 720 }} aria-label="dealer users">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#c52b2b' }}>
                        <TableCell sx={{ width: '18%', color: '#ffffff', fontWeight: 700 }}>Nickname</TableCell>
                        <TableCell sx={{ width: '22%', color: '#ffffff', fontWeight: 700 }}>Email</TableCell>
                        <TableCell sx={{ width: '16%', color: '#ffffff', fontWeight: 700 }}>Status</TableCell>
                        <TableCell sx={{ width: '24%', color: '#ffffff', fontWeight: 700 }}>Roles</TableCell>
                        <TableCell sx={{ width: '20%', color: '#ffffff', fontWeight: 700 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userData.map((user) => (
                        <TableRow
                          key={user.UserID}
                          sx={{
                            '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                            '&:last-child td, &:last-child th': { borderBottom: 0 }
                          }}
                        >
                          <TableCell sx={{ color: '#111111' }}>{user.Nickname}</TableCell>
                          <TableCell sx={{ color: '#111111' }}>{user.Email}</TableCell>
                          <TableCell sx={{ color: '#111111' }}>{user.Status}</TableCell>
                          <TableCell sx={{ color: '#111111' }}>{user.Roles.join(', ')}</TableCell>
                          <TableCell sx={{ color: '#111111', whiteSpace: 'nowrap' }}>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(user.UserID)}
                              sx={{ color: '#c52b2b' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleupdateOpen(user)}
                              sx={{ color: '#111111' }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Users;
